import { useEffect, useState } from 'react';

import { fg } from '@atlaskit/platform-feature-flags';

import { UC_AVAILABLE_ACTIONS_URL_PATH } from '../../constants';
import { AvailableObjectResponse, MenuItem } from '../../types';

import { transformItems } from './utils';

function getHomeUrl() {
	return new URL(window.location.href).origin;
}

export function useUniversalCreateApi() {
	const [items, setItems] = useState<MenuItem[]>([]);

	async function fetchData(): Promise<AvailableObjectResponse | undefined> {
		try {
			const url = `${getHomeUrl()}${UC_AVAILABLE_ACTIONS_URL_PATH}`;

			const response = await fetch(url, {
				credentials: 'include',
			});

			return (await response.json()) as AvailableObjectResponse;
		} catch (e) {
			return undefined;
		}
	}

	useEffect(() => {
		if (fg('navx_universal_create_cross_app_creation_enabled')) {
			fetchData().then(async (response) => {
				if (response?.items) {
					setItems(await transformItems(response.items));
				}
			});
		}
	}, []);

	return { items };
}
